// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","layout__main":"Layout_layout__main__rnefV"};